export { MainHeroV2 } from './MainHeroV2';
